module.exports = __webpack_public_path__ + "img/472.b15a1a40.gif";